document.addEventListener('DOMContentLoaded', function() {
    mvSlideTrigger();
    twitterFncTorigger();
    productFollowingBtnToggle();
    colFilterMaxpriceWidthToggle();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      mvSlideTrigger();
      twitterFncTorigger();
      productFollowingBtnToggle();
      colFilterMaxpriceWidthToggle();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      mvSlideTrigger();
      twitterFncTorigger();
      productFollowingBtnToggle();
      colFilterMaxpriceWidthToggle();
    });
}


/****************************************
    ブレイクポイントの分岐CSS追加
****************************************/
const customBreakpoint = 1000;
const body = document.querySelector('body');
window.addEventListener("load",() => {
    if (customBreakpoint < window.innerWidth) {
        body.classList.add('w-pc');
    } else {
        body.classList.remove('w-pc');
    }
}, false);
window.addEventListener("resize",() => {
    if (customBreakpoint < window.innerWidth) {
        body.classList.add('w-pc');
    } else {
        body.classList.remove('w-pc');
    }
}, false);


/****************************************
    メインビジュアルスライダーJS
****************************************/
function mvSlideTrigger() {
  if ($('.c-mvisual__section').length > 0) {
    mvSlide();
  }
}

function mvSlide () {
  $(".c-mvisual__section").each(function(i){
      $(this).find(".slider").attr("data-slick", i);
      $(this).find(".slider-nav").attr("data-slick", i);
  });

  let mvThumbNum;
    const mvThumbIndex = $('.c-mvisual__section .thumbnail-img').last().data('slideIndex');
    if(mvThumbIndex <= 6) {
        mvThumbNum = mvThumbIndex;
    } else {
        mvThumbNum = mvThumbIndex - 2;
    }
  
  $('.c-mvisual__section .slider').each(function(){
      let attr = $(this).attr('data-slick');
  
      $(this).slick({
          autoplay: true,
          arrows: true,
          centerMode: true,
          centerPadding: "28%",
          speed: 1000,
          asNavFor: '.slider-nav[data-slick="'+attr+'"]',
          prevArrow: '<button class="slide-arrow prev-arrow"><span class="c-arrowsvg"></span></button>',
          nextArrow: '<button class="slide-arrow next-arrow"><span class="c-arrowsvg"></span></button>',
          responsive: [
              {
                  breakpoint: 700,
                  settings: {
                      centerPadding: "5%",
                  },
              },
          ],
      });
      $('.slider-nav[data-slick="'+attr+'"]').slick({
          slidesToShow: mvThumbNum,
          centerMode: true,
          speed: 1000,
          asNavFor: '.slider[data-slick="'+attr+'"]',
          focusOnSelect: true,
          responsive: [
              {
                  breakpoint: 700,
                  settings: {
                      slidesToShow: 3,
                  },
              },
          ],
      });

      $('html').on('click', function() {
        if ($(this).hasClass('lock')) {
          $('.c-mvisual__section .slider').slick('slickPause');
        } else {
          $('.c-mvisual__section .slider').slick('slickPlay');
        }
      });
    
  });
};


/****************************************
    トップへ戻るボタンJS
****************************************/
$(function(){
  const pagetop = $('.c-smoothscroll-top');
  pagetop.hide();

  $(window).scroll(function () {
     if ($(this).scrollTop() > 60) {
          pagetop.fadeIn();
     } else {
          pagetop.fadeOut();
     }
  });
  pagetop.click(function () {
     $('body, html').animate({ scrollTop: 0 }, 500);
     return false;
  });

  $(window).on("scroll", function () {
    scrollHeight = $(document).height(); 
    scrollPosition = $(window).height() + $(window).scrollTop(); 
    footHeight = $("footer").innerHeight(); 
    btnHeight = pagetop.height();
    btnMiddleHeight = btnHeight * 0.66;
    footerFixHeight = footHeight - Math.round(btnMiddleHeight) ;
    if (scrollHeight - scrollPosition <= footHeight - btnHeight) {
      pagetop.css({ position: "absolute", bottom: footerFixHeight }); 
    } else { 
      //下側から20px上げた位置に配置
      pagetop.css({ position: "fixed", bottom: "20px" }); 
    }
  });
});


/****************************************
      Twitterの遅延読み込み
****************************************/
function twitterFncTorigger() {
    if (document.querySelector('.c-info__box') !== null) {
        twitterFnc();
    }
};

function twitterFnc() {
  function insertFnc() {
      const twitterScript = document.createElement('script');
      twitterScript.type = 'text/javascript';
      // twitterScript.async = true;
      twitterScript.src = 'https://platform.twitter.com/widgets.js';
      const twitterBox = document.querySelector('.c-info__box');
      twitterBox.insertBefore(twitterScript, null);
  }
  
  let lazyLoad = false;
  function onLazyLoad() {
      if (lazyLoad === false) {
          lazyLoad = true;
          window.removeEventListener('scroll', onLazyLoad);
          window.removeEventListener('mousemove', onLazyLoad);
          window.removeEventListener('mousedown', onLazyLoad);
          window.removeEventListener('touchstart', onLazyLoad);
          window.removeEventListener('keydown', onLazyLoad);
          insertFnc();
      }
  }
  window.addEventListener('scroll', onLazyLoad);
  window.addEventListener('mousemove', onLazyLoad);
  window.addEventListener('mousedown', onLazyLoad);
  window.addEventListener('touchstart', onLazyLoad);
  window.addEventListener('keydown', onLazyLoad);
  window.addEventListener('load', function() {
      if (window.pageYOffset) {
          onLazyLoad();
      }
  });
}


/****************************************
    商品ページの追従ボタンJS
****************************************/
function productFollowingBtnToggle() {
    if (document.querySelector('product-sticky-bar') !== null) {
        productFollowingBtn();
    }
};

function productFollowingBtn() {
  const productFolBtn = document.querySelector('product-sticky-bar');
  
    const toriggerEl = document.querySelector('.c-mainproduct buy-buttons .button[type="submit"]');
    const fadeoutEl = document.querySelector('footer');
    let scroll_posi, windowHeight, target_posi, fadeout_posi;
  
      if (toriggerEl !== null) {
      window.addEventListener('scroll', function () {
  
          function checkBreakPoint() {
            let w = window.innerWidth;
            if (w <= 700) {
                scroll_posi = window.scrollY;
                windowHeight = window.innerHeight; 
                target_posi = toriggerEl?.getBoundingClientRect().top;
                fadeout_posi = fadeoutEl?.getBoundingClientRect().top + scroll_posi;
            }
          }
          window.addEventListener("resize", function () {
              checkBreakPoint();
          });
          checkBreakPoint();
  
          if (target_posi <= 0 && scroll_posi <= fadeout_posi - windowHeight) {
              productFolBtn.classList.add('is-show');
          } else {
               productFolBtn.classList.remove('is-show');
          }
      });
    }
}


/****************************************
    コレクションページフィルター最大料金の横幅調整JS
    (FireFox&Safariブラウザ対応用)
****************************************/
function colFilterMaxpriceWidthToggle() {
    if (document.querySelector('.c-price-range__max') !== null) {
        colFilterMaxpriceWidth();
    }
};

function colFilterMaxpriceWidth() {
  const priceRangeMax = document.querySelector('.c-price-range__max');
  const maxPlaceholder = priceRangeMax.placeholder;
  let textWidth = 8;

  for (let i = 0; i < 10; i++) {
    if (maxPlaceholder.length == i) {
        const textStyle = textWidth * i;
        priceRangeMax.style.width = textStyle + 'px';
    }
  }
}


/****************************************
    商品カート追加時、カートドット更新JS
****************************************/
const cartDot = document.querySelector('.header__cart-dot');
const buyButtons =  document.querySelectorAll('.buy-buttons .button[type="submit"]');
const inputEl = document.querySelector('.product-info  .quantity-selector__input ');

buyButtons.forEach(button => {
  button.addEventListener('click', () => {
    setTimeout(() => {
      changeCartCount();
    },1200);
  });
});

 async function changeCartCount() {
   const res = await fetch('/cart.js');
   const cart = await res.json();
   cartDot.innerText = cart.item_count;
   cartDot.style.transform = "none";
 }